export default (callback) => {
  onMounted(() => {
    document.addEventListener('click', callback);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', callback);
  });
};
